export function keepScroll(func: () => void) {
  const sc = window.onscroll;
  const x = window.scrollX;
  const y = window.scrollY;
  func();

  window.onscroll = () => {
    window.scrollTo(x, y);
    window.onscroll = sc;
  };
}
